<template>
<div class="chapter">
<div class="inner_page">
<p class="C243"><em><a id="page_xvii">Author’s Note on Names</a></em></p><a id="page_xvii">
<p class="P25">There are many Huxleys in this book. To distinguish between the two on whom I focus most closely, Thomas Henry Huxley and Julian Huxley, I use ‘Huxley’ for the grandfather and ‘Julian’ for the grandson.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Author_s_Note_on_Names.vue?31fbaeca